import { useState } from "react";
import axios from "axios";
import { API, useAuth } from "@/App";
import { useLang } from "@/i18n/LangContext";
import { Shield } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function GdprConsent() {
  const { user, token, setUser } = useAuth();
  const { t } = useLang();
  const [accepting, setAccepting] = useState(false);

  if (!user || user.is_admin || user.gdpr_consent) return null;

  // Hide cookie banner while GDPR popup is active so it can't block clicks
  const cookieBanner = document.querySelector('[data-testid="cookie-consent-banner"]');
  if (cookieBanner) cookieBanner.style.display = "none";

  const accept = async () => {
    setAccepting(true);
    try {
      await axios.post(`${API}/auth/gdpr-consent`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUser({ ...user, gdpr_consent: true });
    } catch (err) {
      console.error("GDPR consent failed:", err);
    } finally {
      setAccepting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] bg-black/70 backdrop-blur-sm flex items-center justify-center p-6" data-testid="gdpr-consent-overlay">
      <div className="bg-[#0a0a0a] border border-purple-500/30 rounded-xl p-8 max-w-md w-full shadow-[0_0_40px_rgba(192,38,211,0.15)]" data-testid="gdpr-consent-dialog">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-10 h-10 flex items-center justify-center bg-purple-500/10 rounded-lg">
            <Shield className="w-5 h-5 text-purple-400" />
          </div>
          <h2 className="text-lg font-bold text-white">{t("gdpr_title")}</h2>
        </div>
        <p className="text-sm text-neutral-300 leading-relaxed mb-4">
          {t("gdpr_text", { username: user.name || user.username || "" })}
        </p>
        <p className="text-xs text-neutral-500 mb-6 italic">
          {t("gdpr_purpose")}
        </p>
        <Button
          onClick={accept}
          disabled={accepting}
          className="w-full bg-purple-600 hover:bg-purple-500 text-white font-bold py-3 border border-purple-400 shadow-[0_0_20px_rgba(192,38,211,0.3)] hover:shadow-[0_0_30px_rgba(192,38,211,0.6)] transition-all duration-300 uppercase tracking-widest text-xs h-12"
          data-testid="gdpr-accept-btn"
        >
          <Shield className="w-4 h-4 mr-2" />
          {accepting ? "..." : t("gdpr_accept")}
        </Button>
      </div>
    </div>
  );
}
